"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loggingAttemptUserClick = void 0;
const attemptUserClick_1 = require("../../../dataLayer/apisWithoutCache/slr/loggingApis/attemptUserClick");
const loggingAttemptUserClick = (body) => {
    return (0, attemptUserClick_1.postAttemptUserClick)(body);
};
exports.loggingAttemptUserClick = loggingAttemptUserClick;
